<template>
	<div v-if="loaderStore.isLoading" class="overlay">
		<div class="loading"></div>
	</div>
</template>

<script lang="ts" setup>
import { useLoaderStore } from '@/stores/loader';

const loaderStore = useLoaderStore();
</script>

<style lang="css" scoped>
.overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999999999;
}

.loading {
	width: 80px;
	height: 80px;
	border-radius: 50%;
	border: 8px solid #ddd;
	border-top-color: #070707;
	animation: loading 0.8s linear infinite;
}

@keyframes loading {
	to {
		transform: rotate(360deg);
	}
}
</style>
